<p-fieldset [legend]="legend">
  <div *ngFor="let line of addressLines; let i = index">
    <div class="col-12 inputFields">
      <!--Label-->
      <div class="col-6"><p>{{line.sDataLib}}</p></div>
      <!--Input field-->
      <div class="col-6">
        <input pInputText type="text" [(ngModel)]="addressLines[i].sDataLibValue" [ngClass]="{'valid': isValid(line), 'not-valid': !isValid(line)}">
      </div>
    </div>
  </div>
</p-fieldset>
